import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import type { IRowDefault } from 'shared/ui/TableNew'
import { Actions } from 'shared/ui'
import commonStyles from 'shared/ui/TableNew/ui/Table.module.scss'
import styles from 'shared/ui/TableNew/ui/TableRow/styles.module.scss'

type IActionsProps<TRow> = {
  row: TRow
  isRightOptionsOpen: boolean
  setIsRightOptionsOpen: (value: boolean) => void
  isHoveredRowActions: boolean | undefined
}

export const ActionsRow = observer(
  <TRow extends IRowDefault>({
    row,
    isRightOptionsOpen,
    setIsRightOptionsOpen,
    isHoveredRowActions,
  }: IActionsProps<TRow>) => {
    return (
      <td
        className={classNames(styles.rowRightActions, commonStyles.rowRightActions, {
          [styles.hoveredRow]: isRightOptionsOpen,
          [styles.hoveredRowActions]: isHoveredRowActions,
        })}
      >
        {!(row.isDisabled || row.origin?.isDisabled) && (
          <Actions
            iconButtonProps={{
              size: 'small',
              ariaLabel: 'TableRow_actions',
              color: 'tertiary',
            }}
            justifyContent={'flex-end'}
            noVisibleActions={!((row.actionsProps?.showItems ?? 0) > 0)}
            onChangeOpen={setIsRightOptionsOpen}
            {...row.actionsProps}
            showItems={row.actionsProps?.showItems ?? 0}
            actions={row.actionsProps?.actions || row.actions || []}
          />
        )}
      </td>
    )
  }
)
